/* eslint-disable no-tabs */
import AboutUsLine from '@/components/AboutUsLine';
import Achievements from '@/components/desktop/Achievements';
import FooterBar from '@/components/desktop/FooterBar/mobile';
import GoyoloArticle from '@/components/desktop/GoyoloArticle';
import GoyoloInvestors from '@/components/desktop/GoyoloInvestor';
import GoyoloStatistics from '@/components/desktop/GoyoloStatistics';
import HeaderBar from '@/components/HeaderBar';
import WhyGoyolo from '@/components/desktop/WhyGoyolo';
import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import {
  Box, Grid, Stack, Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import Head from 'next/head';
import React from 'react';
import GoyoloPartner from '@/components/desktop/GoyoloPartner';
import { useDispatch } from 'react-redux';

import dynamic from 'next/dynamic';
import { useCheckIsMobile } from '@/utils/hooks/use-check-is-mobile';

const AboutGoyoloContentDesktop = dynamic(() => import('./desktop'));

const ImageContainer = styled(Box)`
  height: 100%;
  top: 0px;
  left: 0px;
  width: 100%;
  background: url("https://storage.googleapis.com/goyolo-production/cover.png")
    50% 50% / cover;
  position: absolute;
`;

const Container = styled(Box)`
  position: relative;
`;
const LandingPageWrapper = styled(Box)`
  position: relative;
`;

const Page = styled('div')`
  min-height: 100%;
`;

const AboutGoyoloContent = () => (
  <Stack>
    <Container
      sx={{
        height: {
          xs: '200px',
          md: '300px',
        },
      }}
    >
      <ImageContainer />
      <LandingPageWrapper
        sx={{
          padding: {
            xs: '0 20px',
            md: '0 144px',
          },
        }}
      >
        <Grid
          position="relative"
          container
        >
          <Grid
            item
            sx={{
              mt: {
                xs: pr`24px`,
                md: pr`72px`,
              },
              mb: pr`32px`,
            }}
            xs={12}
          >
            {' '}
            <Stack
              spacing={{
                xs: pr`24px`,
                md: pr`16px`,
              }}
              alignItems="center"
            >
              <img
                src="https://storage.googleapis.com/goyolo-production/logo-white.png"
                alt="logo"
                className="lazyload"
                style={{
                  width: pr`150px`,
                  height: pr`62px`,
                }}
              />
              <Typography
                component="h1"
                variant="title"
                sx={{
                  fontWeight: 500,

                  color: style.color.white4,
                }}
              >
                So sánh phương tiện và đặt vé dễ dàng
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </LandingPageWrapper>
    </Container>
    <Stack
      spacing="64px"
      sx={{
        background: style.color.white4,
        padding: {
          xs: '0 16px',
          md: '0 144px',
        },
        paddingTop: '24px !important',
        paddingBottom: '24px!important',
      }}
    >
      <AboutUsLine
        title="Về Goyolo"
        content="Chúng tôi là một phần của VeXeRe, hệ thống vé xe lớn nhất Việt Nam. Goyolo - nền tảng đặt vé đầu tiên ở Việt Nam cho phép người dùng so sánh giá cả, giờ khởi hành, tổng thời gian di chuyển, đánh giá chất lượng giữa máy bay, xe khách, xe lửa trên cùng một màn hình. Chúng tôi đồng hành với bạn qua những hành trình phiêu lưu khám phá. Lựa chọn Goyolo không chỉ là sự tiện lợi nhanh chóng mà còn giúp trải nghiệm đặt vé của bạn thú vị hơn."
        imageUrl="https://storage.googleapis.com/goyolo-production/intro-10.png"
        align="left"
      />
      <WhyGoyolo />
      <GoyoloStatistics />
      <AboutUsLine
        title="Go! You Only Live Once!"
        content="Tại Goyolo, chúng tôi tin vào những cuộc hành trình.
      Goyolo ra đời với sứ mệnh truyền cảm hứng đến những người yêu sự dịch chuyển, hãy bắt đầu những chuyến hành trình chưa từng có, những cuộc phiêu lưu khám phá văn hóa, khám phá những miền đất mới, gặp gỡ những con người mới để mở rộng tâm hồn, để hiểu được bản thân mình hơn, từ đó có thể sống trọn vẹn một lần với chính mình.
      "
        imageUrl="https://storage.googleapis.com/goyolo-production/intro-11.png"
        align="right"
      />
      <AboutUsLine
        title="Những người sáng lập"
        content="Goyolo còn là hành trình phiêu lưu từ những người sáng lập nên nó:
      <ul>
              <li>
        Anh Văn, Founder, quyết định bỏ học tại Mỹ để trở về Việt Nam bắt đầu hành trình xây dựng Vexere.
        </li>
        <li>
        Anh Thắng, Co-founder, gác lại tương lai xán lạn tại 1 công ty đa quốc gia để cùng gầy dựng công ty.
        </li>
        <li>
          Anh Long, Co-founder, rời khỏi ngôi nhà tại Hàn Quốc sau khoảng thời gian dài an cư lập nghiệp để trở về Việt Nam bắt đầu 1 hành trình mới.

        </li>

      </ul>
      Và điểm chung của 3 cuộc hành trình trên là hành trình trở về với chính mình, được dẫn lối bởi tinh thần luôn tiến về phía trước và khát khao cống hiến để cách mạng hoá lĩnh vực giao thông vận tải và du lịch của Việt Nam."
        imageUrl="https://storage.googleapis.com/goyolo-production/intro-8.png"
        align="left"
      />
      <AboutUsLine
        title="Về VeXeRe - Công ty chủ quản của Goyolo"
        content="Được thành lập từ năm 2013 với 3 đồng sáng lập: anh Đào Việt Thắng, anh Lương Ngọc Long và anh Trần Nguyễn Lê Văn, công ty cổ phần VeXeRe đã xây dựng được tên tuổi hàng đầu trong ngành xe khách, với bề dày hoạt động trong lĩnh vực Thương mại điện tử, Công nghệ và du lịch. VeXeRe là đơn vị đi đầu trong sự nghiệp cách mạng ngành xe khách Việt Nam."
        imageUrl="https://storage.googleapis.com/goyolo-production/intro-9.png"
        align="right"
      />
      <Achievements />
      <GoyoloPartner />
      <GoyoloInvestors />
      <GoyoloArticle />
    </Stack>
  </Stack>
);

const AboutGoyoloPage = () => {
  const isMobile = useCheckIsMobile();
  if (!isMobile) {
    return <AboutGoyoloContentDesktop />;
  }
  return (
    <Page>
      <Head>
        <title>Giới thiệu Goyolo | Goyolo</title>
        <meta
          name="description"
          content="Goyolo.com là một nền tảng đặt vé máy bay, xe khách, tàu hoả,... nhanh chóng, tiện lợi với mức giá rẻ nhất"
        />
      </Head>
      <HeaderBar />
      <AboutGoyoloContent />
      <FooterBar />
    </Page>
  );
};
export default AboutGoyoloPage;
